import {
  AfterViewInit,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { BaseComponent } from '@library-shared/base/base.component';
import { spTicket_List_Selected } from '@models/StoredProcs/spTicket_List_Selected';

@Component({
  selector: 'app-tickets-to-pay',
  templateUrl: './tickets-to-pay.component.html',
  styleUrls: ['./tickets-to-pay.component.scss'],
  standalone: false,
})
export class TicketsToPayComponent extends BaseComponent implements OnInit, AfterViewInit {
  @Input() ticketList: spTicket_List_Selected[] = [];
  @Input() validationGroup;

  constructor() {
    super();
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.loadData();
  }

  loadData() {}

  ticketTypeName(ticketType: string): string {
    switch (ticketType) {
      case 'T':
        return 'Traffic Summons';
      case 'P':
        return 'Parking Summons';
      case 'R':
        return 'Red Light Notice';
      case 'S':
        return 'Speeding Notice';
    }
    return '?';
  }
}
